import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { emailTemplateList, getEmailTemplateDetail, emailTemplateMasterList } from "../../api/company";
const initialState = {
  list: [],
  master_list: [],
  total: 0,
  details: {},
};

export const EmailTemplateSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    list: (state, action) => {
      state.list = action.payload;
    },
    masterList: (state, action) => {
      state.master_list = action.payload;
    },
    detail: (state, action) => {
      state.details = action.payload;
    },
    totalCount: (state, action) => {
      state.total = action.payload;
    },
  },
});

export const FetchEmailTemplateList = createAsyncThunk(
  "emailTemplateList",
  async (obj, { dispatch }) => {
    try {
      const response = await emailTemplateList(obj);
      if (response?.code === 1) {
        dispatch(list(response?.data?.email_list));
        dispatch(totalCount(response?.data?.total_emails));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const FetchMasterEmailTemplateList = createAsyncThunk(
  "emailTemplateList",
  async (obj, { dispatch }) => {
    try {
      const response = await emailTemplateMasterList(obj);
      if (response?.code === 1) {
        dispatch(masterList(response?.data?.email_list));
        dispatch(totalCount(response?.data?.total_emails));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const FetchEmailTemplateDetail = createAsyncThunk(
  "getCompanyDetail",
  async (obj, { dispatch }) => {
    const response = await getEmailTemplateDetail(obj);
    if (response?.code === 1) {
      console.log(response, "Email Template details");
      dispatch(detail(response?.data?.email_template));
    }
    return response;
  }
);

export const { list, detail, totalCount, masterList } = EmailTemplateSlice.actions;

export default EmailTemplateSlice.reducer;
